import { getCurrentPortalCommunicationOperator } from '@app/shared/utils/communication-operator.util';
import { portalConfig, ServiceSortingOption } from '../entities';
import { ServiceOffering } from './../../shared/types/service-offering';
import {
  filterInternetPhoneBundles,
  filterInternetTvBundles,
  filterOtherServices,
  filterPhoneServices,
  filterSelectedOffers,
  filterSpeed1000,
  filterSpeed250,
  filterSpeed2500,
  filterSpeed500,
  filterSpeed5000,
  filterSpeedInterval30To100,
  filterSpeedSlow,
  filterTvServices,
  filterUniqueOffers,
  sortBySpeedThenPrice,
} from './shared-service-filters.util';

/**
 * filtering and sorting.
 * List is always shuffled in order.
 * @param services List of services to filter
 * @param filter Filter to apply
 * @returns filtered list of services
 */
export function servicesFilterAndSort(
  services: ServiceOffering[],
  filter: ServiceSortingOption
): ServiceOffering[] {
  let filteredServices: ServiceOffering[];
  const currentPortal = getCurrentPortalCommunicationOperator();
  switch (filter) {
    case 'SELECTED_OFFERS_PLACEHOLDER':
      filteredServices = filterSelectedOffers(services);
      break;
    case 'UNIQUE_OFFERS':
      return filterUniqueOffers(services).sort(sortBySpeedThenPrice);
    case 'INTERNET_AND_PHONE_BUNDLE':
      filteredServices = filterInternetPhoneBundles(services);
      break;
    case 'ADDITIONAL_SERVICES':
      filteredServices = filterOtherServices(services);
      break;
    case 'SPEED_5000':
      filteredServices = filterSpeed5000(services);
      break;
    case 'SPEED_2500':
      filteredServices = filterSpeed2500(services);
      break;
    case 'SPEED_1000':
      filteredServices = filterSpeed1000(services);
      break;
    case 'SPEED_500':
      filteredServices = filterSpeed500(services);
      break;
    case 'SPEED_250':
      filteredServices = filterSpeed250(services);
      break;
    case 'SPEED_100':
      filteredServices = filterSpeedInterval30To100(services);
      break;
    case 'SPEED_SLOW':
      filteredServices = filterSpeedSlow(services);
      break;
    case 'INTERNET_AND_TV_BUNDLE':
      filteredServices = filterInternetTvBundles(services);
      break;
    case 'ONLY_TV':
      filteredServices = filterTvServices(services);
      break;
    case 'ONLY_PHONE':
      filteredServices = filterPhoneServices(services);
      break;
    case 'ALL_OFFERS':
    default:
      filteredServices = services;
      break;
  }

  return portalConfig[currentPortal].sortFn(filteredServices);
}
